import { Component, OnInit, signal, inject, input, output } from '@angular/core';

import { FollowUpDialogComponent } from './follow-up-dialog/follow-up-dialog.component';
import { map } from 'rxjs';
import { IncompleteGpAddressTableData } from '../../../../../types/gp-letters';
import { GpAddressFollowUpApiService } from '../../../../../api/gpaddresses/slugs/address-id/orders/slugs/visit-id/followup/followup.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'followup-button',
    imports: [],
    templateUrl: './followup.component.html',
    styleUrl: './followup.component.scss'
})
export class FollowupComponent implements OnInit {
    private gpAddressFollowUpApiService = inject(GpAddressFollowUpApiService);
    private dialog = inject(MatDialog);

    readonly address = input<IncompleteGpAddressTableData | null>(null);
    readonly messageSentEmitter = output();
    readonly disabled = signal<boolean>(true);

    ngOnInit() {
        const address = this.address();
        if (address?.lastContacted) {
            const timePlus24hr = new Date(address.lastContacted);
            timePlus24hr.setHours(timePlus24hr.getHours() + 24);
            const now = new Date();
            if (timePlus24hr > now) {
                setTimeout(() => {
                    this.disabled.set(false);
                }, timePlus24hr.getTime() - now.getTime());
            } else {
                this.disabled.set(false);
            }
        } else {
            this.disabled.set(false);
        }
    }

    openFollowUpModal() {
        const address = this.address();
        if (address) {
            const dialogRef = this.dialog.open(FollowUpDialogComponent, {
                data: {
                    addressId: address.gpaddress_id,
                    visitId: address.visit_id,
                },
            });
            dialogRef.afterClosed().subscribe(data => {
                if (data) {
                    const { address_id, visit_id, message } = data;
                    this.gpAddressFollowUpApiService
                        .sendFollowUpMessage(address_id, visit_id, message)
                        .pipe(
                            map(() => {
                                this.messageSentEmitter.emit();
                                const addressValue = this.address();
                                if (addressValue) {
                                    addressValue.noOfContacts += 1;
                                    this.disabled.set(true);
                                }
                            }),
                        )
                        .subscribe();
                }
            });
        }
    }
}
